import {queryQuizServerGqlApi} from "../graphql/queryQuizServerGqlApi";

import {listQuizzes as listQuizzesGraphQL} from '../graphql/queries';
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listQuizzes = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string, 
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    const variables: any = {
        wsId: wsId,
    };
    if (limit) {
        variables.limit = limit;
    }
    if (nextToken) {
        variables.nextToken = nextToken;
    }
    return await queryQuizServerGqlApi(
        dataClientService,
        authService,
        listQuizzesGraphQL,
        variables,
    );
}
